import { useMemo } from 'react'
import EditableCell from './EditTableCell'
import EditableRow from './EditableRow'
import TableHasPagenation from './TableHasPagenation'
import { Link } from 'react-router-dom'
import service from "../@services";
const components = {
  body: {
    row: EditableRow,
    cell: EditableCell
  }
}

export default function ProductListTable({
  otherColumns = [],
  pageData = {},
  loading = false,
  isLink = false,
  rowKey = 'skuId',
  storeCode = '',
  editList = [],
  getList = () => {},
  handleSave = () => {}
}) {
  const basicColoums = [
    {
      title: '商品信息',
      dataIndex: 'productName',
      render: (text, record) => {
        return (
          <div style={{ fontSize: 12 }}>
            <div style={{ color: '#1890ff' }}>{
              isLink? <Link style={{ color: '#1890ff' }} to={{pathname:'/product/store-product/page', query: {barcode: record.barcode,storeId: storeCode}}}>{record.productName}</Link>: record.productName}</div>
            <div>商品编码：{record.productCode}</div>
            <div>商品条码：{record.barcode}</div>
          </div>
        )
      }
    },
    {
      title: '商品类别',
      dataIndex: 'categoryName'
    },
    {
      title: '规格',
      dataIndex: 'specification'
    },
    {
      title: '单位',
      dataIndex: 'unit'
    }
  ]
  const finalCol = useMemo(
    () =>
      [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          render: (text, record, index) =>
            (pageData.pageIndex - 1) * pageData.pageSize + (index + 1)
        },
        ...basicColoums,
        ...otherColumns
      ].map(item => {
        return editList.indexOf(item.dataIndex) > -1
          ? {
              ...item,
              onCell: record => {
                return {
                  record,
                  editable: true,
                  dataIndex: item.dataIndex,
                  title: item.title,
                  handleSave: handleSave,
                  inputFormatter: item.formatter
                }
              }
            }
          : item
      }),
    [editList, otherColumns]
  )
  return (
    <TableHasPagenation
      pageData={pageData}
      components={components}
      rowKey={rowKey}
      loading={loading}
      onPageSizeChange={getList}
      columns={finalCol}
    />
  )
}
